import { createFileRoute } from "@tanstack/react-router";

import { AutoScale } from "../components/site/AutoScale";
import { Breadcrumbs } from "../components/site/Breadcrumbs";
import { Footer } from "../components/site/Footer";
import { Header } from "../components/site/Header";
import { ScrollToTop } from "../components/site/ScrollToTop";
import { Reveal } from "../components/site/Reveal";
import { SpecialOffer } from "../components/home/SpecialOffer";
import { ContactsInfo } from "../components/contacts/ContactsInfo";
import { ContactsMap } from "../components/contacts/ContactsMap";
import { FeedbackDialog } from "../components/contacts/FeedbackDialog";
import { TELEGRAM_URL } from "../lib/nav";
import { ContactForm } from "../components/home/ContactForm";
import { breadcrumbJsonLd, buildMeta, SITE_URL } from "../lib/site";
import { crumbTuples } from "../lib/breadcrumbs";
import starIcon from "../assets/svg/958608a3-718f-49ec-8.svg.asset.json";

const title = "Контакты HAY.agency — маркетинговое агентство в Москве";
const description =
  "Адрес, телефон, email и форма связи с маркетинговым агентством HAY.agency. Обсудите сайт, рекламу, SEO, CRM или разработку веб-сервиса.";


export const Route = createFileRoute("/contacts")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/contacts",
      image: `${SITE_URL}/og/default.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "Контакты HAY.agency",
      locale: "ru_RU",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "ContactPage",
              "@id": `${SITE_URL}/contacts#page`,
              url: `${SITE_URL}/contacts`,
              name: title,
              description,
              isPartOf: { "@id": `${SITE_URL}/#website` },
              about: { "@id": `${SITE_URL}/#organization` },
            },
            {
              "@type": "LocalBusiness",
              "@id": `${SITE_URL}/contacts#localbusiness`,
              parentOrganization: { "@id": `${SITE_URL}/#organization` },
              name: "hay.agency",
              telephone: "+74951322256",
              email: "info@hay.agency",
              url: `${SITE_URL}/contacts`,
              address: {
                "@type": "PostalAddress",
                addressLocality: "Москва",
                streetAddress: "ул. Правды 8к13",
              },
              openingHoursSpecification: [
                {
                  "@type": "OpeningHoursSpecification",
                  dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                  opens: "10:00",
                  closes: "20:00",
                },
              ],
            },
            breadcrumbJsonLd(crumbTuples("/contacts"), { inGraph: true }),
          ],
        }),
      },
    ],
  }),
  component: ContactsPage,
});

function ContactsPage() {
  return (
    <AutoScale>
      <div className="min-h-screen bg-background font-sans text-foreground antialiased">
        <SpecialOffer />
        <Header />
        <main>
          <section className="mx-auto w-full px-5 pt-4 lg:px-[21px] lg:pt-[28px]">
            <Breadcrumbs current="Контакты" />
            <Reveal priority className="mt-8 grid gap-8 lg:mt-[46px] lg:grid-cols-[minmax(0,1fr)_minmax(0,420px)] lg:items-end">
              <h1 className="section-title">Контакты</h1>
              <div className="hidden lg:flex lg:flex-wrap lg:items-center lg:gap-[42px]">
                <Actions />
              </div>
            </Reveal>
          </section>
          <ContactsInfo />
          <ContactsMap />
          <ContactForm />
          <div className="mx-auto -mt-8 flex w-full flex-wrap items-center gap-5 px-5 pb-2 sm:gap-8 lg:hidden">
            <Actions />
          </div>

        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </AutoScale>
  );
}

function Actions() {
  return (
    <>
      <a
        href={TELEGRAM_URL}
        target="_blank"
        rel="noreferrer"
        className="btn-label inline-flex h-[53px] w-[calc(52%)] items-center justify-center whitespace-nowrap bg-brand px-6 text-brand-foreground transition-colors duration-300 hover:bg-foreground hover:text-background sm:w-auto"
      >
        Запрос на встречу
      </a>
      <FeedbackDialog
        trigger={
          <button
            type="button"
            className="btn-label underline decoration-[1px] underline-offset-[6px] transition-colors duration-300 hover:text-brand-text"
          >
            Обратная связь
          </button>
        }
      />
      <img
        src={starIcon.url}
        alt=""
        aria-hidden="true"
        className="spin-star h-[26px] w-[26px] opacity-[0.32]" loading="lazy" decoding="async" />
    </>
  );
}
